exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-goal-strapi-goal-document-id-js": () => import("./../../../src/pages/goal/{StrapiGoal.documentId}.js" /* webpackChunkName: "component---src-pages-goal-strapi-goal-document-id-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

